import { useListRoleAssignments } from "@/queries/group-queries";
import { useListRunners } from "@/queries/runner-queries";
import { ResourceType } from "gitpod-next-api/gitpod/v1/event_pb";
import { useMemo } from "react";

export function useGroupRunners(groupId: string) {
    const { data: assignments, isLoading: isLoadingAssignments } = useListRoleAssignments({
        resourceType: ResourceType.RUNNER,
        groupId,
    });

    const runnerIds = useMemo(() => assignments?.assignments.map((a) => a.resourceId) ?? [], [assignments]);

    const { runners: allRunners, isLoading: isLoadingRunners } = useListRunners({});

    const runners = useMemo(
        () => (allRunners ?? []).filter((r) => r && runnerIds.includes(r.runnerId)),
        [allRunners, runnerIds],
    );

    return {
        runners,
        isLoading: isLoadingAssignments || isLoadingRunners,
    };
}
